interface IProps {
  left: JSX.Element;
  right: JSX.Element;
  hasDivider?: boolean;
  isReversed?: boolean;
  className?: string;
}

export const TwoColumn = ({
  left,
  right,
  hasDivider,
  isReversed,
  className,
}: IProps) => {
  return (
    <div
      className={`flex flex-col w-full justify-center
      ${isReversed ? "md:flex-row-reverse" : "md:flex-row"} 
      ${className}`}
    >
      <div className={"self-center md:w-2/5 relative"}>{left}</div>
      {hasDivider && (
        <hr
          className={
            "md:h-auto my-4 md:my-0 md:mx-8 border-l border-primary-800"
          }
        />
      )}
      <div className={"self-center md:w-2/5 relative"}>{right}</div>
    </div>
  );
};
